import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { AutoUnsubscribe } from '../../core/decorators/auto-unsubscribe';
import { ConfirmService } from './confirm.service';
import {FormControl, FormGroup, Validators} from '@angular/forms';

@Component({
    selector: 'dms-confirm',
    templateUrl: './confirm.component.html',
    styleUrls: ['./confirm.component.scss']
})
@AutoUnsubscribe()
export class ConfirmComponent implements OnInit {

    sub: Subscription;

    showConfirm: boolean = false;

    @ViewChild('focus', { static: false }) inputElement: ElementRef;

    inputForm: FormGroup;

    constructor(public _confirmService: ConfirmService) {
        this.sub = this._confirmService.observerConfirm().subscribe(show => {
            this.showConfirm = show;
            if (this.showConfirm) {
                this.initForm();
                this.focusButton();
            }
        });

    }

    ngOnInit(): void {
    }

    private initForm() {
        const validators = this._confirmService.confirmConfig.textInputValidations ? this._confirmService.confirmConfig.textInputValidations : [];
        const defaultValue = this._confirmService.confirmConfig.textInputDefaultValue ? this._confirmService.confirmConfig.textInputDefaultValue : '';
        this.inputForm = new FormGroup({
            text: new FormControl(defaultValue, validators)
        });
    }

    hasButtonCancel() {
        return { 'mr-2': this._confirmService.confirmConfig.onButtonCancel }
    }

    hasButtonAltOrCandel() {
        return { 'mr-2': this._confirmService.confirmConfig.onButtonAlternative || this._confirmService.confirmConfig.onButtonCancel }
    }

    accept(): void {
        if (this.inputForm.invalid) {
            return;
        }
        if (this._confirmService.confirmConfig.onButtonAccept) {
            if (this._confirmService.confirmConfig.textInput) {
                this._confirmService.confirmConfig.onButtonAccept(this.inputForm.get('text').value);
            } else {
                this._confirmService.confirmConfig.onButtonAccept();
            }
        }
        this._confirmService.showConfirm(false);
    }

    alternative(): void {
        if (this._confirmService.confirmConfig.onButtonAlternative) {
            if (this._confirmService.confirmConfig.textInput) {
                this._confirmService.confirmConfig.onButtonAlternative(this.inputForm.get('text').value);
            } else {
                this._confirmService.confirmConfig.onButtonAlternative();
            }
        }
        this._confirmService.showConfirm(false);
    }

    cancel(): void {
        this._confirmService.confirmConfig.onButtonCancel();
        this._confirmService.showConfirm(false);
    }

    focusButton(){
        setTimeout(()=>{
            this.inputElement.nativeElement.focus();
        },0);
      }

}
